import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUservoiceRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		fill: "#FF6720",
		clipPath: "url(#uservoiceRegularClip0)",
		children: [/* @__PURE__ */ _jsx("path", { d: "m21.8 3-4.3 3v15.3q0 2.2-1.8 3.5-1.6-1.4-1.6-3.5v-.9c0-.8-.9-1.7-.9-2.6q.1-.8.7-1.8a1.7 1.7 0 0 0-1.6-2.5q-1.6.2-1.7 1.8l.2.7q.6 1 .7 1.8c0 .9-.9 1.8-.9 2.6v.9q0 2.4 1.3 4.1c-1.7-.6-3-2.2-3-4.1v-.9c0-.8-.9-1.7-.9-2.6q.1-.8.7-1.8A1.7 1.7 0 0 0 7 13.4q-1.5.2-1.7 1.8l.2.7q.6 1 .7 1.8c0 .9-.9 1.8-.9 2.6v.9a7.8 7.8 0 0 0 15.6 0V7.6l.8-.6 1 .6V21c0 2.8-1 5.8-4.2 7.8 3.4 0 7.5-3.8 7.6-8.7V6z" }), /* @__PURE__ */ _jsx("path", { d: "M12.4 12.2a1.7 1.7 0 1 0 0-3.5 1.7 1.7 0 0 0 0 3.5m0-4.7a1.7 1.7 0 1 0 0-3.5 1.7 1.7 0 0 0 0 3.5m-5.2 4.7a1.7 1.7 0 1 0 0-3.5 1.7 1.7 0 0 0 0 3.5m0-4.6a1.7 1.7 0 1 0 0-3.5 1.7 1.7 0 0 0 0 3.5" })]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "uservoiceRegularClip0",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#FF6720",
			d: "M5.4 3h20.8v26H5.4z"
		})
	}) })]
});
export default SvgUservoiceRegularIcon;
